import logo from './logo.svg';
import './App.css';

import { useTable, useSortBy, useFilters, useExpanded, usePagination } from 'react-table';
import React, { useEffect, useState } from 'react';

// https://thewidlarzgroup.com/react-table-7/#pagination---usepagingation-hook


// const data = [
//   { firstName: "jane", lastName: "doe", age: 20 },
//   { firstName: "john", lastName: "smith", age: 21 }
// ];

// const columns = [
//   {
//     Header: "First Name",
//     accessor: "firstName"
//   },
//   {
//     Header: "Last Name",
//     accessor: "lastName"
//   }
// ];

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  });

  return (
    <table {...getTableProps()} className="stonks-table">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};


function App() {

  let stonks = [{"company":"SQUARE INC - A","day_high":241.65,"day_low":230.08,"dividend_rate":0,"fifty_two_week_high":283.19,"fifty_two_week_low":32.33,"market_cap":"109.06B","ticker":"SQ"},{"company":"PAYPAL HOLDINGS INC","day_high":251.548,"day_low":244.3026,"dividend_rate":0,"fifty_two_week_high":309.14,"fifty_two_week_low":82.07,"market_cap":"291.72B","ticker":"PYPL"},{"company":"ZILLOW GROUP INC - C","day_high":151.9699,"day_low":146.29,"dividend_rate":0,"fifty_two_week_high":208.11,"fifty_two_week_low":20.04,"market_cap":"36.11B","ticker":"Z"},{"company":"SILVERGATE CAPITAL CORP-CL A","day_high":145.65,"day_low":130,"dividend_rate":0,"fifty_two_week_high":187.864,"fifty_two_week_low":8.11,"market_cap":"3.27B","ticker":"SI"},{"company":"INTERCONTINENTAL EXCHANGE IN","day_high":115.6205,"day_low":114.7517,"dividend_rate":1.32,"fifty_two_week_high":119.02,"fifty_two_week_low":63.51,"market_cap":"64.87B","ticker":"ICE"},{"company":"TENCENT HOLDINGS LTD-UNS ADR","day_high":83.5,"day_low":81.67,"dividend_rate":0.15,"fifty_two_week_high":99.4,"fifty_two_week_low":40.8,"market_cap":"774.64B","ticker":"TCEHY"},{"company":"SEA LTD-ADR","day_high":234.93,"day_low":222.08,"dividend_rate":0,"fifty_two_week_high":285,"fifty_two_week_low":35.61,"market_cap":"120.49B","ticker":"SE"},{"company":"PINTEREST INC- CLASS A","day_high":71.4891,"day_low":67.695,"dividend_rate":0,"fifty_two_week_high":89.9,"fifty_two_week_low":10.1,"market_cap":"44.27B","ticker":"PINS"},{"company":"SHOPIFY INC - CLASS A","day_high":1146,"day_low":1093.4585,"dividend_rate":0,"fifty_two_week_high":1499.75,"fifty_two_week_low":305.3,"market_cap":"137.94B","ticker":"SHOP"},{"company":"ADYEN NV","ticker":"ADYEN"},{"company":"MERCADOLIBRE INC","day_high":1563.115,"day_low":1507.5,"dividend_rate":0,"fifty_two_week_high":2020,"fifty_two_week_low":422.22,"market_cap":"76.5B","ticker":"MELI"},{"company":"ALIBABA GROUP HOLDING-SP ADR","day_high":235.45,"day_low":229.7058,"dividend_rate":0,"fifty_two_week_high":319.32,"fifty_two_week_low":169.95,"market_cap":"611.54B","ticker":"BABA"},{"company":"YEAHKA LTD","ticker":"9923"},{"company":"OPENDOOR TECHNOLOGIES INC","day_high":27.1,"day_low":24.6,"dividend_rate":0,"fifty_two_week_high":39.24,"fifty_two_week_low":10.55,"market_cap":"15.38B","ticker":"OPEN"},{"company":"SNAP INC - A","day_high":60.66,"day_low":57.0863,"dividend_rate":0,"fifty_two_week_high":73.59,"fifty_two_week_low":7.89,"market_cap":"90.66B","ticker":"SNAP"},{"company":"TWILIO INC - A","day_high":371.35,"day_low":357.595,"dividend_rate":0,"fifty_two_week_high":457.3,"fifty_two_week_low":68.056,"market_cap":"62.39B","ticker":"TWLO"},{"company":"ZHONGAN ONLINE P&C INSURAN-H","ticker":"6060"},{"company":"MEITUAN-CLASS B","ticker":"3690"},{"company":"DOCUSIGN INC","day_high":216.86,"day_low":207.69,"dividend_rate":0,"fifty_two_week_high":290.23,"fifty_two_week_low":65.61,"market_cap":"40.01B","ticker":"DOCU"},{"company":"FACEBOOK INC-CLASS A","day_high":269.44,"day_low":264.0262,"dividend_rate":0,"fifty_two_week_high":304.67,"fifty_two_week_low":137.1,"market_cap":"759.13B","ticker":"FB"},{"company":"WORKDAY INC-CLASS A","day_high":252.45,"day_low":246.58,"dividend_rate":0,"fifty_two_week_high":282.77,"fifty_two_week_low":107.75,"market_cap":"60.33B","ticker":"WDAY"},{"company":"APPLE INC","day_high":121.07,"day_low":119.16,"dividend_rate":0.82,"fifty_two_week_high":145.09,"fifty_two_week_low":53.1525,"market_cap":"2.03T","ticker":"AAPL"},{"company":"Z HOLDINGS CORP","ticker":"4689"},{"company":"INTUIT INC","day_high":394.77,"day_low":387.38,"dividend_rate":2.36,"fifty_two_week_high":423.74,"fifty_two_week_low":187.68,"market_cap":"108.05B","ticker":"INTU"},{"company":"AMAZON.COM INC","day_high":3084.57,"day_low":3045.5088,"dividend_rate":0,"fifty_two_week_high":3552.25,"fifty_two_week_low":1626.03,"market_cap":"1.55T","ticker":"AMZN"},{"company":"JD.COM INC-ADR","day_high":86.19,"day_low":83.28,"dividend_rate":0,"fifty_two_week_high":108.29,"fifty_two_week_low":32.7,"market_cap":"134.37B","ticker":"JD"},{"company":"TCS GROUP HOLDING-GDR REG S","ticker":"TCS LI"},{"company":"TELADOC HEALTH INC","day_high":196.76,"day_low":189.36,"dividend_rate":0,"fifty_two_week_high":308,"fifty_two_week_low":102.01,"market_cap":"29.73B","ticker":"TDOC"},{"company":"DISCOVERY LTD","ticker":"DSY"},{"company":"PING AN HEALTHCARE AND TECHN","ticker":"1833"},{"company":"KE HOLDINGS INC","day_high":59,"day_low":56.9375,"dividend_rate":0,"fifty_two_week_high":79.4,"fifty_two_week_low":31.79,"market_cap":"67.47B","ticker":"BEKE"},{"company":"SCHWAB (CHARLES) CORP","day_high":68.21,"day_low":66.76,"dividend_rate":0.72,"fifty_two_week_high":68.21,"fifty_two_week_low":28,"market_cap":"126.34B","ticker":"SCHW"},{"company":"DRAFTKINGS INC - CL A","day_high":74.09,"day_low":69.1,"dividend_rate":0,"fifty_two_week_high":74.09,"fifty_two_week_low":10.9,"market_cap":"28.49B","ticker":"DKNG"},{"company":"HDFC BANK LTD-ADR","day_high":82.47,"day_low":80.66,"dividend_rate":0,"fifty_two_week_high":84.7,"fifty_two_week_low":29.5,"market_cap":"113.98B","ticker":"HDB"},{"company":"GUIDEWIRE SOFTWARE INC","day_high":105.1,"day_low":102.44,"dividend_rate":0,"fifty_two_week_high":134.22,"fifty_two_week_low":71.64,"market_cap":"8.79B","ticker":"GWRE"},{"company":"NVIDIA CORP","day_high":515.46,"day_low":503.6,"dividend_rate":0.64,"fifty_two_week_high":614.9,"fifty_two_week_low":180.68,"market_cap":"316.7B","ticker":"NVDA"},{"company":"BASE INC","ticker":"4477"},{"company":"PINDUODUO INC-ADR","day_high":162.1764,"day_low":156.31,"dividend_rate":0,"fifty_two_week_high":212.6,"fifty_two_week_low":30.2,"market_cap":"196.06B","ticker":"PDD"},{"company":"LENDINGTREE INC","ticker":"TREE UW"},{"company":"TAIWAN SEMICONDUCTOR-SP ADR","day_high":119,"day_low":117.284,"dividend_rate":1.75,"fifty_two_week_high":142.2,"fifty_two_week_low":42.7,"market_cap":"547.8B","ticker":"TSM"},{"company":"LENDINGCLUB CORP","day_high":15.36,"day_low":13.09,"dividend_rate":0,"fifty_two_week_high":15.36,"fifty_two_week_low":4.315,"market_cap":"1.31B","ticker":"LC"},{"company":"BILL.COM HOLDINGS INC","day_high":163.48,"day_low":148.09,"dividend_rate":0,"fifty_two_week_high":195.95,"fifty_two_week_low":23.61,"market_cap":"13B","ticker":"BILL"},{"company":"MARKETAXESS HOLDINGS INC","day_high":523.8975,"day_low":507.58,"dividend_rate":2.64,"fifty_two_week_high":606.45,"fifty_two_week_low":275.5,"market_cap":"19.64B","ticker":"MKTX"},{"company":"JSC KASPI.KZ GDR-REG S","ticker":"KSPI"},{"company":"SPLUNK INC","day_high":137.15,"day_low":133.5201,"dividend_rate":0,"fifty_two_week_high":225.89,"fifty_two_week_low":93.92,"market_cap":"21.69B","ticker":"SPLK"},{"company":"VERISK ANALYTICS INC","day_high":172.72,"day_low":170.12,"dividend_rate":1.16,"fifty_two_week_high":210.66,"fifty_two_week_low":116.61,"market_cap":"28.06B","ticker":"VRSK"},{"company":"LIGHTSPEED POS INC-SUB VOTE","day_high":68.9,"day_low":62.81,"dividend_rate":0,"fifty_two_week_high":82.53,"fifty_two_week_low":28.29,"market_cap":"7.99B","ticker":"LSPD"}]


  // const [stonks, updateStonks] = useState([])

  // useEffect(() => {
  //   // fetch("http://localhost:5000/api/ark/ARKF")
  //   // .then(response => response.json())
  //   // .then(data => {
  //   //   console.log(data.data)
  //   //   updateStonks(data.data)
  //   // });
  // }, [])

  // const data = [{  
  //   name: 'Ayaan',  
  //   age: 26  
  //   },{  
  //    name: 'Ahana',  
  //    age: 22  
  //    },{  
  //    name: 'Peter',  
  //    age: 40      
  //    },{  
  //    name: 'Virat',  
  //    age: 30  
  //    },{  
  //    name: 'Rohit',  
  //    age: 32  
  //    },{  
  //    name: 'Dhoni',  
  //    age: 37  
  //    }]  

  const columns = [{
    Header: 'Company',
    accessor: 'company'
  },{
    Header: 'Ticker',
    accessor: 'ticker'
  },
  {
    Header: 'Market Cap',
    accessor: 'market_cap'
  },
  {
    Header: '52 Week High',
    accessor: 'fifty_two_week_high'
  },
  {
    Header: '52 Week Low',
    accessor: 'fifty_two_week_low'
  },
  {
    Header: 'Dividend Rate',
    accessor: 'dividend_rate'
  }
]

  return (
    <div className="App">
      <header className="App-header">
        <h3>ARKF</h3>
        <Table columns={columns} data={stonks} />
      </header>
    </div>
  );
}

export default App;
